import type { AgentComponentMode } from '@reach/shared-types/agent-components';
import { MODE_COPY } from './agents-copy';
import styles from './ModeBadge.module.css';

interface ModeBadgeProps {
  mode: AgentComponentMode;
}

/** Shows how a component's visibility and control setting appears to tenants. */
export const ModeBadge = ({ mode }: ModeBadgeProps) => (
  <span className={styles.badge} data-mode={mode}>
    {MODE_COPY[mode].label}
  </span>
);
